/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { JJ_Guide, JJ_Help, JJ_Home, JJ_IM_Logo, avatarBlueIcn, mainMenuExpMobile, mainMenuCollMobile } from "../../assets";
import './GenAINavigationMenu.css';
import GenAIGlobalMyLinks from '../../components/header/GenAIGlobalMyLinks'
import GenAIGlobalMyProfile from "../header/GenAIGlobalMyProfile";

export default function GenAINavigationMenu(props) {
    const { customWidth, customHeight, pathName } = props
    const [displayMainMenu, setMainMenuDisplay] = useState(false);
    const [compWidth, setWidth] = useState(0);
    const username = JSON.parse(localStorage.getItem('userdisplayName'));
    var width;

    useEffect(() => {
        if (document.getElementById('username-wrapper')) {
            width = document.getElementById('username-wrapper').offsetWidth;
            setWidth(width)
        }
    });

    if (window.location.pathname !== "/results" && window.location.pathname !== "/old_results" && window.location.pathname !== "/pubMedResults") {
        window.supportingDocsSearchStrategyDescription = undefined;
        window.isSupportingDocs = undefined;
    }

    if (customWidth < 600) {
        return (
            <div className="navigation-menu-wrapper-mobile">
                <span className="navigation-menu-inner-wrapper-mobile">
                    <span style={{ paddingTop: "", width: "95%" }}>
                        <img src={JJ_IM_Logo} height="40" alt="" onClick={e => window.open('/recommended', '_self')} />
                    </span>
                    <span>
                        <span>
                            {!displayMainMenu ?
                                <img src={mainMenuExpMobile} alt="" onClick={e => setMainMenuDisplay(true)} />
                                :
                                <img src={mainMenuCollMobile} alt="" onClick={e => setMainMenuDisplay(false)} />
                            }
                        </span>
                    </span>
                </span>
                <span style={{ padding: "0 5px" }}>
                    {displayMainMenu &&
                        <div className="navigation-sub-menu-wrapper-mobile">
                            <div className="navigation-sub-menu-main-header-mobile">
                                <b style={{ fontSize: "16px" }}>Menu</b>
                                <img src={mainMenuCollMobile} alt="" onClick={e => setMainMenuDisplay(false)} />
                            </div>
                            <div className="navigation-sub-menu-username-mobile">
                                <img src={avatarBlueIcn} width="35" height="30" alt="" />
                                <b>{username}</b>
                            </div>
                            <ul className="navigation-sub-menu-items-mobile">
                                <li>
                                    <Link to="/recommended" > <img src={JJ_Home} height="30" alt="" /><span>Home</span></Link>
                                </li>

                                <li>
                                    <Link to="/advancedsearch"><img src={JJ_Guide} height="30" alt="" /><span>Guide</span></Link>
                                </li>
                                <li>
                                    <Link to="/ManageAlerts" target="_blank"> <img src={JJ_Help} height="30" alt="" /><span>Help</span></Link>
                                </li>
                                <li>
                                    <GenAIGlobalMyLinks customWidth={customWidth} customHeight={customHeight} pathName={pathName} />
                                </li>
                            </ul>
                        </div>
                    }
                    </span>
            </div>
        )
    }
    else if (customWidth >= 600 && customWidth < 1000) {
        return (
            <div className="genAIRecommended-header-wrapper">
                <div className="genAIRecommended-header-right">
                    <img src={JJ_IM_Logo} height="40" alt="" />
                </div>
                <div className="genAIRecommended-header-myLink-myProfile-wrapper" >
                     <GenAIGlobalMyLinks customWidth={customWidth} customHeight={customHeight} pathName={pathName} />
                     <GenAIGlobalMyProfile customWidth={customWidth} customHeight={customHeight} pathName={pathName} />
                </div>
               </div>
        )
    }
    else {
        return (
            <div className="genAIRecommended-header-wrapper">
                <div className="genAIRecommended-header-right">
                    <img src={JJ_IM_Logo} height="40" alt="" />
                </div>
                <div className="genAIRecommended-header-myLink-myProfile-wrapper" >
                     <GenAIGlobalMyLinks customWidth={customWidth} customHeight={customHeight} pathName={pathName}  updateBMAddForHome={props.updateBMAddForHome} />
                     <GenAIGlobalMyProfile customWidth={customWidth} customHeight={customHeight} pathName={pathName} />
                </div>
            </div>
        )
    }
}